
import { parseQueryArguments } from '@/shared'
import { ITableListModel, TABLE_REQUEST_MODE, TableListRequestType, countData, deleteData, getData, patchData, postData } from '../utils/db'

export type TOutTableColumnMapping = {
    field: string,
    type: string,
    format: object,
}

export type TOutTableColumn = {
    _id: string,
    name: string,
    mapping: TOutTableColumnMapping[],
    /** keys of the template's current columns, in its order; missing on old data */
    columns?: string[],
    template: string,
}

export default class OutTableColumnModel implements ITableListModel<TOutTableColumn> {
    constructor() {
    }

    public async list({ mode = TABLE_REQUEST_MODE.PAGINATION, project, page = 0, limit = 10, q = '' }: TableListRequestType) {
        let query = parseQueryArguments(`page=${page}&limit=${limit}`, arguments)
        if (q) query += '&q=' + encodeURI(q)
        if (mode == TABLE_REQUEST_MODE.POSITION) {
            query += '&mode=position'
        }
        return await getData(`/projects/${project}/out?${query}`)
    }

    public async read(project: string, id: string) {
        if (!project) return null as never
        let query = `mapping=1`
        return await getData(`/projects/${project}/out/${id}?${query}`)
    }

    public async create(project: string, data: any) {
        return await postData(`/projects/${project}/out/`, data)
    }

    public async update(project: string, id: string, data: any) {
        return await patchData(`/projects/${project}/out/${id}`, data)
    }

    public async updateMapping(project: string, id: string, data: any) {
        return await patchData(`/projects/${project}/out/mapping-column/${id}`, data)
    }

    public async delete(project: string, id: string) {
        return await deleteData(`/projects/${project}/out/${id}`)
    }
    public async count(project: string) {
        return await countData(`/projects/${project}/out/count`)
    }
}